import { ServiceCategory, TeamMember, Location } from '../types';
import { Beaker, Recycle, Droplets, Building2 } from 'lucide-react';

export const serviceCategories: ServiceCategory[] = [
  {
    id: 'deponierung',
    title: 'Deponierung',
    subtitle: 'Wir führen als akkreditierte Typ-A-Inspektionsstelle gemäß EN ISO/IEC 17020:2012 nachfolgende Beurteilungen gemäß Deponieverordnung 2008 idgF durch.',
    icon: Beaker,
    color: '#009E60',
    items: [
      {
        title: 'Grundlegende Charakterisierung (§12-Inspektionen)',
        description: '',
        details: [
          'Aushubmaterial vor Beginn der Aushubarbeiten (in-situ)',
          'Aushubmaterial nach Beginn der Aushubarbeiten (ex-situ)',
          'ausgewiesenen Flächen gemäß Altlastensanierungsgesetz',
          'Materialien aus dem Gleisbau nach Beginn der Aushub- oder Abraumtätigkeit',
          'sonstige, einmalig anfallende Abfälle',
          'Wiederkehrend anfallende Abfälle',
          'Abfallströme'
        ]
      },
      {
        title: 'Grundlegende Charakterisierung ohne analytische Untersuchung (§13 Inspektionen)',
        details: []
      },
      {
        title: 'Übereinstimmungsbeurteilung (§15-Inspektionen)',
        details: []
      },
      {
        title: 'Identitätskontrolle (§19-Inspektionen)',
        details: []
      }
    ]
  },
  {
    id: 'verwertung',
    title: 'Verwertung',
    subtitle: 'Wir unterstützen Sie bei der Bewertung von Abbruch- und Recyclingmaterialien gemäß Recycling-Baustoffverordnung 2015 idgF.',
    icon: Recycle,
    color: '#009E60',
    items: [
      {
        title: 'Bewertung gemäß Recycling-Baustoffverordnung',
        description: 'Bewertung von Abbruch- und Recyclingmaterialien gemäß Recycling-Baustoffverordnung 2015 idgF:',
        details: [
          'Orientierende und umfassende Schad- und Störstofferkundungen',
          'Deklarationsprüfungen bzw. werkseigene Produktionskontrollen von Recyclingprodukten',
          'Beurteilung von Verkehrsflächen im eingebauten Zustand',
          'Qualitätssicherung für Einzelchargen',
          'Alternative Qualitätssicherungssysteme'
        ]
      },
      {
        title: 'Bewertung gemäß Bundes-Abfallwirtschaftsplan',
        description: 'Als akkreditierte Inspektionsstelle nach Deponieverordnung 2008 idgF sind wir befugt, Aushubmaterialien auch hinsichtlich der Verwertungsmöglichkeiten gemäß Bundes-Abfallwirtschaftsplan zu beurteilen.',
        details: []
      },
      {
        title: 'Beratung hinsichtlich möglicher Verwertungswege',
        description: 'Wir beraten Sie gerne hinsichtlich möglicher stofflicher sowie thermischer Verwertungswege für Ihre Abfälle, wie z.B.:',
        details: [
          'gemäß der Richtlinie für den sachgerechten Einsatz für Pflanzenaschen',
          'gemäß Recyclingholzverordnung 2012 idgF',
          'gemäß Abfallverbrennungsverordnung 2002 idgF',
          'Notifizierungen für die Verbringung ins Ausland'
        ]
      }
    ]
  },
  {
    id: 'abfallwirtschaft',
    title: 'Abfallwirtschaft',
    subtitle: 'Wir beraten Sie bei allen abfallwirtschaftlichen Fragestellungen und begleiten Ihr Vorhaben von der Projektierung bis Kollaudierung.',
    icon: Building2,
    color: '#009E60',
    items: [
      {
        title: 'Baubegleitungen / Bauaufsichten',
        description: '',
        details: [
          'Chemische Baubegleitungen / Bauaufsichten im Rahmen von Aushub- bzw. Abbrucharbeiten',
          'Ökologische Baubegleitungen / Bauaufsichten'
        ]
      },
      {
        title: 'Sanierungen',
        description: '',
        details: [
          'Altlastensanierung',
          'Sanierung von Tankstellen bzw. Umweltschäden sowie Sanierungsbegleitung',
        ]
      },
      {
        title: 'Beratungen',
        description: '',
        details: [
          'Ökologische Beratung (z.B. Neophytenmanagement)',
          'Bewertung von Standorten und Liegenschaften',
          'Erstellung von Ausgangszustandsberichten, Abfallwirtschaftskonzepten, Einreich- und Kollaudierungoperaten sowie Sanierungs- und Entsorgungskonzepten',
          'Abhalten von Schulungen in den Bereichen Abfallwirtschaft, Abbruch & Recycling sowie Wiederverwertung'
        ]
      },
      {
        title: 'Deponien',
        description: '',
        details: [
          'Deponiebau',
          'Deponieaufsicht'
        ]
      },
      {
        title: 'Luftmessungen',
        description: '',
        details: [
          'Messung von Asbest / künstlichen Mineralfasern'
        ]
      },
      {
        title: 'Projektierungen',
        description: '',
        details: [
          'Projektierung von Anlagen und Zwischenlagern',
          'Begleitung vom Einreichprojekt bis zum Genehmigungsverfahren',
          'Einreichprojekte, Anlagen- und Bescheid-Überprüfungen von Seveso-Anlagen',
          'Erstellung und Überprüfung von Vexat-Dokumenten',
          'Schadensabwicklung mit Behörden und Versicherungen'
        ]
      }
    ]
  },
  {
    id: 'wasserwirtschaft',
    title: 'Wasserwirtschaft',
    subtitle: 'Wir beraten und begleiten Sie bei allen wasserwirtschaftlichen Fragestellungen.',
    icon: Droplets,
    color: '#009E60',
    items: [
      {
        title: 'Beprobung & Bewertung',
        description: 'Wir beproben und bewerten alle Arten von Brauch- und Abwässern. Zusätzlich bieten wir eine orientierende Qualitätssicherung von Trinkwasser an.',
        details: [
          'Betriebs- bzw. Prozesswasser',
          'Sickerwasser',
          'Oberflächengewässer',
          'Grundwasser',
          'Orientierende Qualitätssicherung von Trinkwasser'
        ]
      },
      {
        title: 'Leistungsspektrum',
        description: 'Nachfolgend finden Sie einen Auszug unseres Leistungsspektrums:',
        details: [
          'Planung und örtliche Bauaufsichten von Brunnen, Bohrungen und Grundwassersonden',
          'Kollaudierungen',
          'Fremdüberwachung von Wasserversorgungsanlagen',
          'Grundwassermodellierungen',
          'Pumpversuche und Auswertungen',
          'Versickerungsversuche'
        ]
      }
    ]
  }
];

export const heroServiceCategories = [
  {
    id: 'deponierung',
    title: 'Deponierung',
    subtitle: 'Bewertung von Aushubmaterial bzw. sonstigen Abfällen gem. DVO 2008'
  },
  {
    id: 'abfallwirtschaft',
    title: 'Abfallwirtschaft',
    subtitle: 'Begleitung im Zuge von chemischer bzw. ökologischer Bauaufsicht, Altlastensanierung, Deponiebau, Deponieaufsicht uvm.'
  },
  {
    id: 'verwertung',
    title: 'Verwertung',
    subtitle: 'Bewertung von Abbruch- und Recyclingmaterial gem. RBV 2015; \n Bewertung von Aushubmaterial gem. BAWP'
  },
  {
    id: 'wasserwirtschaft',
    title: 'Wasserwirtschaft',
    subtitle: 'Bewertung aller Arten von Brauch- bzw. Abwässern, Grundwasser und Oberflächengewässern;\nOrientierende Trinkwasseruntersuchung'
  }
];

export const shortServiceCatergories = [
  {
    id: 'deponierung',
    title: 'Deponierung',
    subtitle: 'Akkreditierte Inspektionsstelle für Beurteilungen gemäß Deponieverordnung 2008 idgF:',
    icon: Beaker,
    color: '#009E60',
    items: [
      {
        title: '',
        description: '',
        details: [
          'Grundlegende Charakterisierung von Aushubmaterialien',
          'Liegenschaftserkundungen',
          'Bewertung von Gleisschotter',
          'Bewertung von Abfallströmen',
          'Übereinstimmungsbeurteilung',
          'Identitätskontrolle'
        ]
      }
    ]
  },
  {
    id: 'verwertung',
    title: 'Verwertung',
    subtitle: 'Kompetente Fachanstalt für eine sachgerechte Verwertung:',
    icon: Recycle,
    color: '#009E60',
    items: [
      {
        title: '',
        description: '',
        details: [
          'Bewertung gemäß Bundes-Abfallwirtschaftsplan idgF',
          'Bewertung gemäß Recycling-Baustoffverordnung 2015 idgF',
          'Qualitätssicherung',
          'Beratung möglicher Verwertungswege'
        ]
      }
    ]
  },
  {
    id: 'abfallwirtschaft',
    title: 'Abfallwirtschaft',
    subtitle: 'Kompetente Fachanstalt für abfallwirtschaftliche Fragestellungen:',
    icon: Building2,
    color: '#009E60',
    items: [
      {
        title: '',
        description: '',
        details: [
          'Chemische Baubegleitung im Rahmen von Aushub- bzw. Abbrucharbeiten',
          'Ökologische Baubegleitung',
          'Altlastensanierung von Standortuntersuchung bis hin zur Ausstufung',
          'Luft- und Abluftmessungen',
          'Projektierung vom Konzept bis hin zur Kollaudierung',
          'Deponieaufsicht'
        ]
      }
    ]
  },
  {
    id: 'wasserwirtschaft',
    title: 'Wasserwirtschaft',
    subtitle: 'Kompetente Fachanstalt für wasserwirtschaftliche Fragestellungen:',
    icon: Droplets,
    color: '#009E60',
    items: [
      {
        title: '',
        description: '',
        details: [
          'Bewertung von Brauch- und Abwässern',
          'Qualitätssicherung von Trinkwasser',
          'Projektierungen',
          'Örtliche Bauaufsicht',
          'Versuchsdurchführung'
        ]
      }
    ]
  }
];

export const team: TeamMember[] = [
  {
    id: '1',
    name: 'Dipl.-Ing. (FH) Florian Pauk',
    role: 'Geschäftsführung & Projektleitung',
    email: 'florian.pauk@fphc.at'
  },
  {
    id: '2',
    name: 'Dipl.-Ing. (FH) Birgit Pauk',
    role: 'Geschäftsführung & Projektleitung',
    email: 'birgit.pauk@fphc.at'
  },
  {
    id: '3',
    name: 'Silvia Pixner, MSc',
    role: 'Gruppen- & Projektleitung',
    email: 'silvia.pixner@fphc.at',
    phone: '+43 664 18 50 277'
  },
  {
    id: '4',
    name: 'Sarah Kaineder, MSc',
    role: 'Projektleitung, QMB',
    email: 'sarah.kaineder@fphc.at',
    phone: '+43 676 70 34 710'
  },
  {
    id: '5',
    name: 'Josef Hollerweger',
    role: 'Projektbearbeitung',
    email: 'josef.hollerweger@fphc.at',
    phone: '+43 664 88 22 80 41'
  },
  {
    id: '6',
    name: 'Dipl.-Ing. Daniela Karer',
    role: 'Projektbearbeitung, Lager & Logistik',
    email: 'daniela.karer@fphc.at',
    phone: '+43 677 62 09 91 58'
  },
  {
    id: '7',
    name: 'Daniel Dorninger',
    role: 'Lager & Logistik',
    email: 'daniel.dorninger@fphc.at',
    phone: '+43 677 63 68 29 50'
  }
];

export const locations: Location[] = [
  {
    id: '1',
    city: 'Leonding/Rufling',
    address: 'Tischlerbauerstraße 11, 4060 Leonding',
    phone: '+43 664 470 48 58',
    email: 'office@fphc.at',
    coordinates: {
      lat: 48.2772373135053,
      lng: 14.217180924237006
    }
  }
];
